import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const RaceRunnerInfo = withConfig(theme => styled('div', { label: 'RaceRunnerInfo' })`
    display: flex;
    flex-flow: column nowrap;
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 50%;
    }
`);

export const RunnerNameAndPlace = withConfig(theme => styled('div', { label: 'RunnerNameAndPlace' })`
    color: ${theme.star.raceSummary.txtColor};
    display: block;
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3334;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`);

export const RunnerDetailsWrapper = withConfig(theme => styled('div', { label: 'RunnerDetailsWrapper' })`
    color: ${theme.star.raceSummary.txtColorSecondary};
    font-size: ${theme.star.fontSize.xSmall};
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`);

export const RunnerDetails = styled('i', { label: 'RunnerDetails' })`
    font-style: normal;
    position: relative;
    &::after {
        content: '•';
        margin: 0 4px;
    }
    &:last-of-type {
        &::after {
            content: none;
        }
    }
`;

export const RunnerDetailsNumber = styled(RunnerDetails, { label: 'RunnerDetailsNumber' })` 
    margin-right: 2px;
    &::after {
        content: none;
    }
`;
